import React, { useState } from 'react';
import { Video } from 'lucide-react';

/**
 * Renders the best available media for a Ptitconseil: the AI-generated MP4 when present
 * (autoplay, muted, looped, inline) with the AI image as poster and automatic fallback to
 * the still image if the video cannot be played.
 */
export const ConseilMedia = ({ item, className = '', mediaClassName = '', loading = 'lazy', testId = 'conseil-media', showBadge = false }) => {
  const [videoFailed, setVideoFailed] = useState(false);
  const hasVideo = Boolean(item?.video_url) && !videoFailed;

  if (!item?.image_url && !hasVideo) return null;

  return (
    <div className={`relative overflow-hidden ${className}`} data-testid={testId} data-media-type={hasVideo ? 'video' : 'image'}>
      {hasVideo ? (
        <video
          key={item.video_url}
          src={item.video_url}
          poster={item.image_url || undefined}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          onError={() => setVideoFailed(true)}
          className={`w-full h-full object-cover ${mediaClassName}`}
          aria-label={item.titre}
          data-testid={`${testId}-video`}
        />
      ) : (
        <img src={item.image_url} alt={item.titre || ''} loading={loading} className={`w-full h-full object-cover ${mediaClassName}`} data-testid={`${testId}-image`} />
      )}
      {showBadge && hasVideo && (
        <span className="absolute top-2 left-2 inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full bg-black/60 text-white backdrop-blur-sm" data-testid={`${testId}-badge`}>
          <Video className="h-3 w-3" /> Vidéo
        </span>
      )}
    </div>
  );
};
